<template>
  <div v-if="micrositeStore.loading" class="loading-page" />
  <router-view />
  <MediaPlatformLinks v-show="showMediaLinks" />
</template>

<script setup>
  import { onMounted, ref, nextTick } from 'vue'
  import { useRouter } from 'vue-router'
  import MediaPlatformLinks from '@/components/common/MediaPlatformLinks.vue'
  import { useMicrositeStore } from '@/store/Microsites'

  const micrositeStore = useMicrositeStore()
  const router = useRouter()
  const showMediaLinks = ref(false)

  onMounted(() => {
    window.version = `MSCW version: ${import.meta.env.VITE_APP_VERSION || 'dev'}`

    router.afterEach(async () => {
      await nextTick()

      setTimeout(() => {
        // display the footer after the route has loaded
        //  40 is the debounce time for Responsive.init
        showMediaLinks.value = true
        document.body.classList.add('show-gnb')
      }, 40)
    })
  })
</script>

<style lang="scss">
  html,
  body {
    margin: 0;
    font-family: Arial, sans-serif, Helvetica Neue, Helvetica;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    margin: 0;
  }

  #gnt_center {
    display: none !important;
  }
  .gnt-notice-tabs {
    pointer-events: none;
  }
  .gnt-notice-tab {
    pointer-events: all;
  }
  .gnt-nav {
    display: none !important;
  }
  #onetrust-banner-sdk button {
    margin-bottom: 5px !important;
  }

  .show-gnb {
    #globalFooter {
      display: block !important;
    }

    #globalNavigation,
    .global-navigation,
    #globalFooter {
      min-width: 100% !important;
    }
  }

  .loading-page {
    @keyframes rotation {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    border: 6px solid #583615;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }
</style>
